import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logoblanco.png";
import "./Navbar.css";

const Navbar = ({ isAuthenticated, onLogout, userName, userRole }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    // Cerrar menú de usuario si está abierto
    if (userMenuOpen) setUserMenuOpen(false);
  };

  const toggleUserMenu = () => {
    setUserMenuOpen(!userMenuOpen);
    // Cerrar menú principal si está abierto
    if (menuOpen) setMenuOpen(false);
  };

  const closeAllMenus = () => {
    setMenuOpen(false);
    setUserMenuOpen(false);
  };

  // Cerrar menús al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen && !event.target.closest('.navbar-list') && !event.target.closest('.navbar-toggle')) {
        setMenuOpen(false);
      }
      if (userMenuOpen && !event.target.closest('.user-section')) {
        setUserMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [menuOpen, userMenuOpen]);

  // Prevenir scroll cuando el menú está abierto en móvil
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuOpen]);

  const handleLinkClick = () => {
    closeAllMenus();
  };

  const handleLogout = () => {
    onLogout();
    closeAllMenus();
  };

  return (
    <>
      {/* Overlay para móvil */}
      <div 
        className={`mobile-overlay ${menuOpen ? 'active' : ''}`} 
        onClick={closeAllMenus}
      />

      <nav className="navbar">
        {/* Logo */}
        <div className="navbar-brand">
          <Link to="/" className="navbar-logo" onClick={handleLinkClick}>
            <img src={logo} alt="Logo de la empresa" />
          </Link>
        </div>

        {/* Menú hamburguesa */}
        <div className={`navbar-toggle ${menuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Lista de navegación */}
        <ul className={`navbar-list ${menuOpen ? 'active' : ''}`}>
          {/* Inicio */}
          <li>
            <Link to="/" className="navbar-link highlight" onClick={handleLinkClick}>
              🏠 Inicio
            </Link>
          </li>

          {/* Tienda */}
          <li>
            <Link to="/Tienda" className="navbar-link highlight" onClick={handleLinkClick}>
              🛒 Tienda
            </Link>
          </li>

          {/* Usuarios o Panel de Admin/Trabajador */}
          {isAuthenticated ? (
            <li>
              <Link
                to={userRole === "admin" ? "/admin" : "/Trabajador"}
                className="navbar-link subtle"
                onClick={handleLinkClick}
              >
                {userRole === "admin" ? "⚙️ Panel de Admin" : "👷 Panel de Trabajador"}
              </Link>
            </li>
          ) : (
            <li>
              <Link to="/Login" className="navbar-link subtle" onClick={handleLinkClick}>
                👥 Usuarios
              </Link>
            </li>
          )}
        </ul>

        {/* Sección del usuario (lateral derecho) */}
        {isAuthenticated && (
          <div className="user-section">
            <div className="user-info" onClick={toggleUserMenu}>
              <span className="user-name">{userName}</span>
              <span className="user-icon">👤</span>
            </div>

            {/* Menú desplegable del usuario */}
            {userMenuOpen && (
              <ul className="user-menu">
                <li>
                  <button onClick={handleLogout} className="user-menu-link">
                    🚪 Cerrar sesión
                  </button>
                </li>
              </ul>
            )}
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;